export default "__VITE_ASSET__BLQssG8Q__"